import type { FC, ReactNode } from 'react'
import LootShineProvider from '../shared/rewards/LootShineProvider'
import { classNames } from '@g4g/utils/src/react/class-names'
import { useShoppingCart } from '../shopping-cart/ShoppingCartProvider'
import EmptyCart from '../shared/EmptyCart'

type CartPath = 'cart' | 'checkout'

const ShoppingCartPageLayout: FC<{
  title: string
  path: CartPath
  side?: ReactNode
  children?: ReactNode
}> = ({ title, side, children, path }) => {
  const items = useShoppingCart()

  if (items.length === 0) {
    return <EmptyCart />
  }

  return (
    <div>
      <h1
        className={classNames(
          'container pt-0 pr-4 pl-4 pb-4 sm:p-4 mt-2 font-bold text-2xl',
          'text-white sm sm:text-4xl sm:mt-3 font-poppins'
        )}
      >
        {title}
      </h1>
      <LootShineProvider magicNumber={10}>
        <div className="container flex flex-col mb-12 lg:flex-row lg:space-x-7">
          {/* Totals and list of items in cart. */}
          <div className="order-1 mt-4 grow lg:mt-0">{children}</div>
          {/*
            Proceed to checkout sidebar.
            According to https://www.salesforce.com/blog/ux-best-practice-important-add-cart-page-blog/
            It's good to have the checkout button above the fold, that's why `order-0` so it's on top on mobile.
          */}
          {side && (
            <div
              className={classNames(
                'relative flex p-4 text-white rounded',
                'bg-gray-600/20 order-0 lg:order-2 lg:self-start',
                // Prevent layout shifts with min-height
                path === 'cart'
                  ? 'lg:min-w-[350px] min-h-[210px] sm:min-h-60'
                  : 'lg:min-w-[28rem] lg:w-[28rem] lg:min-h-[500px] lg:p-8'
              )}
            >
              {side}
            </div>
          )}
        </div>
      </LootShineProvider>
    </div>
  )
}

export default ShoppingCartPageLayout
